
define('text!templates/custom_alert_dialog.html',[],function () { return '<div class="unload-alert" style="display: none;">\n    <div class="w-body">\n        <div class="icon {{icon}}"><b></b></div>\n        <div class="message">\n            <div class="head">{{title}}</div>\n            <div class="message-c">{{bodyMsg}}</div>\n        </div>\n    </div>\n</div>\n';});

